module.exports = __webpack_public_path__ + "static/smart-home-mobile-plp-a22a21136bf5256ca3b58b63c1660bf5.png";